import styled from 'styled-components';


export const FloatingButton = styled.a`
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 1000; 
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
  }
`;


export const WhatsAppIcon = styled.img`
  width: 60px;
  height: 60px;
  transition: all 0.2s ease-in-out;
  
 
   ${FloatingButton}:hover & {
    transform: scale(1.1);
  }
`;


export const HoverText = styled.span`
  visibility: hidden;
  opacity: 0;
  margin-right: 12px;
  padding: 8px 12px;
  background-color: #25D366;
  color: #ffffff;
  border-radius: 6px;
  white-space: nowrap; 
  transition: all 0.3s ease;
  font-weight: 600;

  
  ${FloatingButton}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;